/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";

// Soft UI Dashboard PRO helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { borderWidth, borderRadius } = borders;

export default {
  styleOverrides: {
    root: ({ theme }) => {
      const mode = theme.palette.mode || "light";
      const { text, background, inputColors } = colors[mode];

      return {
        display: "grid !important",
        placeItems: "center !important",
        width: "100% !important",
        height: "auto !important",
        padding: `${pxToRem(8)} ${pxToRem(12)}`,
        fontSize: `${size.sm} !important`,
        fontWeight: `${fontWeightRegular} !important`,
        lineHeight: "1.4 !important",
        color: `${text.primary} !important`,
        backgroundColor: `${background.paper} !important`,
        backgroundClip: "padding-box !important",
        border: `${borderWidth[1]} solid ${inputColors.borderColor.main}`,
        appearance: "none !important",
        borderRadius: borderRadius.md,
        transition: "box-shadow 150ms ease, border-color 150ms ease, padding 150ms ease !important",

        "&:hover": {
          borderColor: `${inputColors.borderColor.focus}`,
        },

        "&.Mui-focused": {
          borderColor: `${inputColors.borderColor.focus}`,
          boxShadow: `0 0 0 2px ${inputColors.boxShadow}40`,
        },

        "&.Mui-disabled": {
          backgroundColor:
            mode === "dark" ? "rgba(255,255,255,0.04) !important" : "rgb(242, 242, 242) !important",
          borderColor:
            mode === "dark" ? "rgba(255,255,255,0.1) !important" : "rgb(230, 230, 230) !important",
          color:
            mode === "dark" ? "rgba(255,255,255,0.3) !important" : "rgb(153, 153, 153) !important",
          opacity: "1 !important",
        },
      };
    },

    input: ({ theme }) => {
      const mode = theme.palette.mode || "light";
      const { text, background } = colors[mode];

      return {
        width: "100% !important",
        height: `${pxToRem(22)}`,
        padding: "0 !important",
        color: `${text.primary} !important`,

        "&::-webkit-input-placeholder": {
          color: `${text.disabled} !important`,
          opacity: "0.8 !important",
        },

        "&::placeholder": {
          color: `${text.disabled} !important`,
          opacity: "0.8 !important",
        },

        // Override browser autofill background — the only reliable cross-browser fix
        // is an inset box-shadow that "paints over" the forced white/yellow autofill bg.
        "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active":
          {
            WebkitBoxShadow: `0 0 0 1000px ${background.paper} inset !important`,
            WebkitTextFillColor: `${text.primary} !important`,
            caretColor: `${text.primary} !important`,
            // Delay background-color transition long enough that the autofill colour
            // never visually appears before the box-shadow takes effect.
            transition: "background-color 9999s ease-in-out 0s !important",
          },
      };
    },
  },
};
